





























import {Component, Vue} from 'vue-property-decorator';
import ViewBase from '@/views/ViewBase';
import SecurityApi from '@/apis/SecurityApi';
import InitiatePrimaryPasswordResetRequestModel from '@/models/security/InitiatePrimaryPasswordResetRequestModel';

@Component({
        name: 'InitiatePrimaryPasswordReset',
    },
)
export default class InitiatePrimaryPasswordReset extends ViewBase {
    public emailAddress: string = '';

    public emailRules(value: string ): any {
        if ( value.trim().length === 0)
        {
            return 'An email address is required.';
        }

        return true;
    }

    public async resetClick() {

        if ( this.isFormValid() ) {
            try {
                this.resetProcessingValues();

                const request = new InitiatePrimaryPasswordResetRequestModel();
                request.emailAddress = this.emailAddress;

                const api = new SecurityApi();
                const response = await api.initiatePrimaryPasswordResetAsync(request);

                await this.$router.push({name: 'primarypasswordreset'});
            }
            catch ( err ) {
                await this.handleProcessingErrorAsync(err);
            }
            finally {
                this.processing = false;
            }
        }
    }

    private isFormValid(): boolean {
        const form: any = this.$refs.resetForm;

        return form.validate();
    }

}
